import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './HeroSlider.css';

const HeroSlider = () => {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoplay, setIsAutoplay] = useState(true);

  const formatTitle = (title) => {
    const lines = title.split('\n');
    return lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const slides = [
    {
      id: 1,
      eyebrow: t('hero_slide_1_eyebrow'),
      title: t('hero_slide_1_title'),
      description: t('hero_slide_1_description'),
      image: '/images/image14.png',
      avatar: 'https://images.unsplash.com/photo-1544723795-3fb6469f5b39?w=80&h=80&fit=crop',
      primaryCta: t('hero_slide_primary_cta'),
      // secondaryCta: t('hero_slide_secondary_cta')
    },
    {
      id: 2,
      eyebrow: t('hero_slide_2_eyebrow'),
      title: t('hero_slide_2_title'),
      description: t('hero_slide_2_description'),
      image: '/images/image13.jpeg',
      avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop',
      primaryCta: t('hero_slide_primary_cta'),
      // secondaryCta: t('hero_slide_secondary_cta')
    },
    {
      id: 3,
      eyebrow: t('hero_slide_3_eyebrow'),
      title: t('hero_slide_3_title'),
      description: t('hero_slide_3_description'),
      image: '/images/image15.png',
      avatar: 'https://images.unsplash.com/photo-1525134479668-1bee5c7c6845?w=80&h=80&fit=crop',
      primaryCta: t('hero_slide_primary_cta'),
      // secondaryCta: t('hero_slide_secondary_cta')
    },
    {
      id: 4,
      eyebrow: t('hero_slide_4_eyebrow'),
      title: t('hero_slide_4_title'),
      description: t('hero_slide_4_description'),
      image: '/images/image16.png',
      avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=80&h=80&fit=crop',
      primaryCta: t('hero_slide_primary_cta'),
      // secondaryCta: t('hero_slide_secondary_cta')
    },
    {
      id: 5,
      eyebrow: t('hero_slide_5_eyebrow'),
      title: t('hero_slide_5_title'),
      description: t('hero_slide_5_description'),
      image: '/images/image8.jpeg',
      avatar: 'https://images.unsplash.com/photo-1494797710133-75adf6c1f4a3?w=80&h=80&fit=crop',
      primaryCta: t('hero_slide_primary_cta'),
      // secondaryCta: t('hero_slide_secondary_cta')
    }
  ];

  useEffect(() => {
    if (!isAutoplay) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoplay, slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoplay(false);
    setTimeout(() => setIsAutoplay(true), 5000);
  };

  return (
    <section className="hero-slider" id="home">
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
            style={{
              backgroundImage: `url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className="slide-overlay"></div>
            <div className="slide-content">
              <div className="container">
                <div className="slide-text">
                  <p
                    className={`slide-eyebrow ${
                      index === currentSlide ? 'fade-in' : ''
                    }`}
                  >
                    {slide.eyebrow}
                  </p>
                  <h1 className={`slide-title ${index === currentSlide ? 'fade-in' : ''}`}>
                    {formatTitle(slide.title)}
                  </h1>
                  <p className={`slide-description ${index === currentSlide ? 'fade-in' : ''}`}>
                    {slide.description}
                  </p>
                  <div className={`slide-buttons ${index === currentSlide ? 'fade-in' : ''}`}>
                    <Link to="/donation" className="btn btn-primary">{slide.primaryCta}</Link>
                    {slide.secondaryCta && (
                      <Link to="/about" className="btn btn-secondary">{slide.secondaryCta}</Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="slider-dots">
        {slides.map((slide, index) => (
          <button
            key={slide.id}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          ></button>
        ))}
      </div>

      <div className="hero-bottom-card">
        <div className="hero-bottom-avatars">
          <div className="hero-bottom-avatar">
            <img
              src="https://images.unsplash.com/photo-1525134479668-1bee5c7c6845?w=80&h=80&fit=crop"
              alt="Volunteer 1"
            />
          </div>
          <div className="hero-bottom-avatar">
            <img
              src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop"
              alt="Volunteer 2"
            />
          </div>
          <div className="hero-bottom-avatar">
            <img
              src="https://images.unsplash.com/photo-1494797710133-75adf6c1f4a3?w=80&h=80&fit=crop"
              alt="Volunteer 3"
            />
          </div>
        </div>
        <div className="hero-bottom-text">
          <span>Empowering lives</span> through your kindness
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;
